import {UsersDrawerItem} from "./UsersDrawerItem";
import {UsersContent} from "./UsersContent";
import {DrawerItemData} from "../../app/types";

export const UsersComponent: DrawerItemData = {
    uid: "users",
    drawerItem: UsersDrawerItem,
    content: UsersContent
};
